
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRainShowersMon as ObiRainShowersMonElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-rain-showers-mon.js';
 
 
 

 
 export const ObiRainShowersMon = createComponent({
   react: React,
   tagName: 'obi-rain-showers-mon',
   elementClass: ObiRainShowersMonElement,
   events: {
     
   }
  });
 
 